module.exports = __webpack_public_path__ + "media/kommissar_1.2a.4a87595e.mp3";